import { queryOptions, useQuery } from '@tanstack/react-query';
import { filterProducts, type ProductFilter } from '../domain/product';
import { productsApi } from '../infrastructure/api';

export const productKeys = {
  all: ['products'] as const,
  list: () => [...productKeys.all, 'list'] as const,
};

export const productsQuery = queryOptions({
  queryKey: productKeys.list(),
  queryFn: productsApi.list,
  staleTime: 5 * 60_000,
});

/** A lista inteira vem uma vez; marca e favoritos filtram no cliente. */
export function useProducts(filter: ProductFilter) {
  return useQuery({ ...productsQuery, select: (list) => filterProducts(list, filter) });
}

/** Um produto pelo slug, a partir da mesma lista em cache. */
export function useProduct(slug: string | undefined) {
  return useQuery({
    ...productsQuery,
    enabled: !!slug,
    select: (list) => list.find((p) => p.slug === slug) ?? null,
  });
}
